import {Injectable} from '@angular/core';
import {tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import { HttpClient, HttpParams, HttpHeaders, HttpRequest, HttpEventType } from '@angular/common/http';
import {map, catchError} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(private http: HttpClient) {}

  post(url: string, data: any, options?: any): Observable<any> {
    url = environment.API_URL + url;
    return this.http.post(url, data, options);
  }

  patch(url: string, data: any) {
    url = environment.API_URL + url;
    return this.http.patch(url, data);
  }

  get(url: string) {
    return this.http.get(environment.API_URL + url);
  }

  put(url: string, data: any) {
    url = environment.API_URL + url;
    return this.http.put(url, data);
  }

  delete(url: string, data: any) {
    url = environment.API_URL + url;
    return this.http.delete(url, data);
  }
}
